export default __webpack_public_path__ + "assets/images/b7648cbd0c76624f163040b2fc16cd14.jpg";